// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");
var DataField$ReactHooksTemplate = require("../data_fields/dataField.res.js");

function id(t) {
  return t.id;
}

function dataField(t) {
  return t.dataField;
}

function position(t) {
  return t.position;
}

function setDataField(t, x) {
  return {
          id: t.id,
          dataField: x,
          position: t.position
        };
}

function setPosition(t, x) {
  return {
          id: t.id,
          dataField: t.dataField,
          position: x
        };
}

function empty(param) {
  return {
          id: undefined,
          dataField: DataField$ReactHooksTemplate.empty(),
          position: undefined
        };
}

function decode(json) {
  return {
          id: Json_decode.optional((function (param) {
                  return Json_decode.field("id", Json_decode.$$int, param);
                }), json),
          dataField: Json_decode.field("data_field", DataField$ReactHooksTemplate.decode, json),
          position: Json_decode.optional((function (param) {
                  return Json_decode.field("position", Json_decode.$$int, param);
                }), json)
        };
}

function encode(destroyOpt, position, t) {
  var destroy = destroyOpt !== undefined ? destroyOpt : false;
  var payloadPosition = position !== undefined ? position : t.position;
  return Json_encode.object_({
              hd: [
                "id",
                Json_encode.nullable((function (prim) {
                        return prim;
                      }), t.id)
              ],
              tl: {
                hd: [
                  "data_field_id",
                  Json_encode.nullable((function (prim) {
                          return prim;
                        }), DataField$ReactHooksTemplate.id(t.dataField))
                ],
                tl: {
                  hd: [
                    "position",
                    Json_encode.nullable((function (prim) {
                            return prim;
                          }), payloadPosition)
                  ],
                  tl: {
                    hd: [
                      "_destroy",
                      destroy
                    ],
                    tl: /* [] */0
                  }
                }
              }
            });
}

exports.id = id;
exports.dataField = dataField;
exports.position = position;
exports.setDataField = setDataField;
exports.setPosition = setPosition;
exports.empty = empty;
exports.decode = decode;
exports.encode = encode;
/* DataField-ReactHooksTemplate Not a pure module */
